import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import apiDefinitions from '../../../../core/api/apiDefinitions';
import { showError, showSuccess } from '../../../../core/alert/sweetAlertConfig';

interface WindowDTO {
  id: number;
  windowName: string;
  roomId: number;
  floorId: number;
}

interface UpdateWindowModuleProps {
  show: boolean;
  onHide: () => void;
  window: WindowDTO;
  onSuccess: () => void;
}

const UpdateWindowModule: React.FC<UpdateWindowModuleProps> = ({ show, onHide, window, onSuccess }) => {
  const [windowName, setWindowName] = useState(window.windowName);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setWindowName(window.windowName);
  }, [window]);

  const handleSubmit = async () => {
    if (!windowName.trim()) {
      showError('Window name is required.');
      return;
    }
    setIsLoading(true);
    try {
      const payload = { id: window.id, windowName, roomId: window.roomId };
      const response = await apiDefinitions.updateWindow(payload);
      if (response.status === 200 && (response.data.status === 'S1000' || response.data.status === 'SUCCESS')) {
        showSuccess("Window updated successfully");
        onSuccess();
        onHide();
      } else {
        showError(response.data?.statusDescription || 'Failed to update window.');
      }
    } catch (err: any) {
      showError(err.response?.data?.statusDescription || 'Failed to update window. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Window</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Window Name</label>
          <input
            type="text"
            className="form-control"
            value={windowName}
            onChange={(e) => setWindowName(e.target.value)}
            placeholder="Enter window name"
            disabled={isLoading}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Room ID</label>
          <input type="text" className="form-control" value={window.roomId} disabled />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="secondary" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Updating...' : 'Update'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateWindowModule;